import React, { useEffect, useState } from 'react';
import { useParams } from 'react-router-dom';
import axios from 'axios';
import { Box, Typography, Paper, CardMedia } from '@mui/material';
import { Helmet } from 'react-helmet';
import parse from 'html-react-parser'; // Import parsera

// Domyślny obrazek, jeśli pole image jest puste
const defaultImage = '/images/default-article.jpg';

const ArticlePage = () => {
  const { slug } = useParams();
  const [article, setArticle] = useState(null);
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState(null);

  useEffect(() => {
    setLoading(true);
    setError(null);
    axios.get(`${process.env.REACT_APP_API_URL}/api/articles/${slug}`)
      .then(response => {
        console.log('Pobrany artykuł:', response.data);
        setArticle(response.data);
        setLoading(false);
      })
      .catch(error => {
        console.error('Błąd podczas pobierania artykułu:', error);
        if (error.response && error.response.status === 404) {
          setError('Artykuł nie znaleziony.');
        } else {
          setError('Nie udało się pobrać artykułu. Spróbuj ponownie później.');
        }
        setLoading(false);
      });
  }, [slug]);

  if (loading) {
    return (
      <Box sx={{ textAlign: 'center', padding: '20px' }}>
        <Typography variant="h6">Ładowanie...</Typography>
      </Box>
    );
  }

  if (error) {
    return (
      <Box sx={{ textAlign: 'center', padding: '20px' }}>
        <Typography variant="h6">{error}</Typography>
      </Box>
    );
  }

  if (!article) {
    return (
      <Box sx={{ textAlign: 'center', padding: '20px' }}>
        <Typography variant="h6">Artykuł nie znaleziony.</Typography>
      </Box>
    );
  }

  return (
    <>
      <Helmet>
        <title>{article.metaTitle || article.title}</title>
        <meta name="description" content={article.metaDescription || 'Przeczytaj artykuł na naszym blogu.'} />
        <meta name="author" content={article.author} />
        <meta name="robots" content="index, follow" />
      </Helmet>
      <Box sx={{ padding: { xs: '20px', md: '40px' }, maxWidth: '800px', margin: '0 auto' }}>
        <Typography variant="h4" sx={{ mb: 2 }}>
          {article.title}
        </Typography>
        <Typography variant="body2" color="text.secondary" sx={{ mb: 3 }}>
          {article.publishedAt} | Autor: {article.author}
        </Typography>
        {article.image && (
          <CardMedia
            component="img"
            height="300"
            image={article.image || defaultImage}
            alt={article.title}
            sx={{ objectFit: 'cover', mb: 3, borderRadius: '8px' }}
          />
        )}
		<Paper sx={{ p: 3, backgroundColor: '#2c2c2c', '& h2': { fontSize: '1.5rem', margin: '1rem 0' }, '& p': { margin: '0.5rem 0' }, '& strong': { fontWeight: 'bold' } }}>
		  <div className="article-content">
			{parse(article.content || 'Brak treści.')}
		  </div>
		</Paper>
      </Box>
    </>
  );
};

export default ArticlePage;